import { render, staticRenderFns } from "./ReminderReportList.vue?vue&type=template&id=d6f29672&"
import script from "./ReminderReportList.vue?vue&type=script&lang=js&"
export * from "./ReminderReportList.vue?vue&type=script&lang=js&"
import style0 from "./ReminderReportList.vue?vue&type=style&index=0&id=d6f29672&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports